import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiPath from "../config/apiPaths.json";
import { apiRequest } from "../infrastructure/backendService";
import { hallRentalListProps } from "../infrastructure/GlobalContextProvider";

export interface hallDetailsTypes {
  devoteeID: string;
  hallName: string;
  hallId: number | null;
  hallHours: number;
  hallmins: number;
  halldesc: string;
  hallAmount: string | number;
  date: string;
  time: string;
  isManagerRequest: boolean;
  poojaHallRequestsId: number | null;
  totalHoursFee: string | number;
  securityDeposit: string | number;
  setupAndCleaningFee: string | number;
}

export interface poojaBooking {
  hallList: hallRentalListProps[];
  hallBookingDetails: hallDetailsTypes;
}

const initialState: poojaBooking = {
  hallList: [],
  hallBookingDetails: {
    devoteeID: "",
    hallName: "",
    hallId: null,
    hallHours: 0,
    hallmins: 0,
    halldesc: "",
    hallAmount: 0,
    date: "",
    time: "",
    isManagerRequest: false,
    poojaHallRequestsId: null,
    totalHoursFee: 0,
    securityDeposit: 0,
    setupAndCleaningFee: 0,
  },
};

export const fetchHallList = createAsyncThunk(
  "hallBooking/fetchHallList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest({
        method: "GET",
        endpoint: apiPath.hallRentalList,
        includeToken: true,
      });
      return response?.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const hallbookingSlice = createSlice({
  name: "hallBooking",
  initialState,
  reducers: {
    addHallBookingDetails: (state, action) => {
      state.hallBookingDetails = {
        ...state.hallBookingDetails,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHallList.fulfilled, (state, action) => {
      state.hallList = action.payload;
    });
    builder.addCase(fetchHallList.rejected, (state, action) => {
      state.hallList = [];
    });
  },
});

export const { addHallBookingDetails } = hallbookingSlice.actions;

export default hallbookingSlice.reducer;
